<div fxLayout="column" fxLayoutAlign="stretch">
  <button
    *ngIf="isGuest; else notGuest"
    aria-label="Login"
    class="btn btn-primary"
    title="Login"
    type="button"
    (click)="login()"
  >
    Login
  </button>

  <ng-template #notGuest>
    <ng-container *ngIf="item?.hasAccount; else hasNoAccount">
      <ng-container *ngIf="item?.isCheckedOut; else notCheckedOut">
        <button
          aria-label="Early Return Hoopla"
          class="btn btn-primary"
          title="Early Return"
          type="button"
          (click)="earlyReturn()"
        >
          Early Return
        </button>

        <button
          role="button"
          type="button"
          aria-label="'Get' format"
          class="btn btn-primary"
          (click)="goToHooplaFulfillment()"
        >
          Get {{ format }}
        </button>
      </ng-container>
      <ng-template #notCheckedOut>
        <button
          *ngIf="showCheckOut"
          aria-label="Checkout"
          class="btn btn-primary"
          title="Checkout"
          type="button"
          (click)="checkout()"
          [disabled]="disableCheckout"
          [ngClass]="{ 'greyed-out': disableCheckout }"
        >
          Checkout
        </button>
        <button
          *ngIf="showCancelHold"
          aria-label="Cancel Hold"
          class="btn btn-primary"
          title="Cancel Hold"
          type="button"
          (click)="cancelHold()"
        >
          Cancel Hold
        </button>
      </ng-template>
      <ng-container *ngIf="showPlaceHold">
        <button
          aria-label="Place Hold"
          class="btn btn-primary"
          title="Place Hold"
          type="button"
          (click)="placeHold()"
        >
          Place Hold
        </button>
      </ng-container>
    </ng-container>
    <ng-template #hasNoAccount>
      <button
        *ngIf="item"
        role="button"
        type="button"
        aria-label="Create Hoopla Account"
        class="btn btn-primary"
        (click)="goToHoopla()"
      >
        Create Hoopla Account
      </button>
    </ng-template>
  </ng-template>
</div>
